module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.026da48c.jpg";